import * as React from 'react';

import { MAP_VISIBLE_RESTRICT_AREA } from '../constants';

const MAX_WEST_LONGITUDE_GAP = 0.000001;

function getLongitudeShift(width: number, zoom: number): number {
  return (width / Math.pow(2, zoom + 8)) * 360;
}

export function getExpandedRestrictArea(listingAreaWidth: number, zoom: number): [YMaps.TCoord, YMaps.TCoord] {
  const [southWest, northEast] = MAP_VISIBLE_RESTRICT_AREA;
  const expandedWestLongitude = southWest[1] - getLongitudeShift(listingAreaWidth, zoom);
  const minWestLongitude = northEast[1] + MAX_WEST_LONGITUDE_GAP;
  const safeWestLongitude = Math.max(expandedWestLongitude, minWestLongitude);

  return [[southWest[0], safeWestLongitude], northEast];
}

export function useListingRestrictMapArea(map: YMaps.Map, listingAreaWidth: number): void {
  React.useEffect(() => {
    if (listingAreaWidth <= 0) {
      map.options.set('restrictMapArea', MAP_VISIBLE_RESTRICT_AREA);

      return undefined;
    }

    let appliedZoom: number | undefined;
    const applyRestrictArea = () => {
      const zoom = map.getZoom();

      if (appliedZoom === zoom) {
        return;
      }

      appliedZoom = zoom;
      map.options.set('restrictMapArea', getExpandedRestrictArea(listingAreaWidth, zoom));
    };

    applyRestrictArea();
    map.events.add('boundschange', applyRestrictArea);

    return () => {
      map.events.remove('boundschange', applyRestrictArea);
      map.options.set('restrictMapArea', MAP_VISIBLE_RESTRICT_AREA);
    };
  }, [listingAreaWidth, map]);
}
